<div class="header-overlay" style="overflow: scroll" *ngIf="showOverlay">
  <div class="header-overlay-container">
    <ul class="list-unstyled shop-menu" *ngIf="commerceNavigation">
      <li *ngFor="let section of shopSections" class="shop-menu__section">
        <button type="button" class="shop-menu__toggle text-white fs-22" (click)="toggleSection(section)"
          [attr.aria-expanded]="openSection === section.key">
          {{ section.label }} <span class="shop-menu__caret" aria-hidden="true">{{ openSection === section.key ? "&minus;" : "+" }}</span>
        </button>
        <div class="shop-menu__panel" *ngIf="openSection === section.key" [ngSwitch]="section.key">
          <ng-container *ngSwitchCase="'attachments'">
            <a class="shop-menu__link shop-menu__link--strong" routerLink="/shop/attachments">Shop all attachments</a>
            <div *ngFor="let machine of attachmentMachineTypes" class="shop-menu__group">
              <button type="button" class="shop-menu__subtoggle" (click)="toggleMachine(machine.handle)" [attr.aria-expanded]="openMachine === machine.handle">
                {{ machine.name }} <span aria-hidden="true">{{ openMachine === machine.handle ? "&minus;" : "+" }}</span>
              </button>
              <div class="shop-menu__subpanel" [hidden]="openMachine !== machine.handle">
                <a class="shop-menu__link shop-menu__link--strong" [routerLink]="['/shop', 'attachments', machine.handle]">Shop all {{ machine.name }} attachments</a>
                <a *ngFor="let category of categoriesFor(machine.handle)" class="shop-menu__link" [routerLink]="['/shop', 'attachments', machine.handle, category.handle]">{{ category.name }}</a>
              </div>
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'locations'">
            <div *ngFor="let location of locations" class="shop-menu__group">
              <button type="button" class="shop-menu__subtoggle" (click)="toggleState(location.stateAbbr)" [attr.aria-expanded]="openState === location.stateAbbr">
                {{ location.state }} <span aria-hidden="true">{{ openState === location.stateAbbr ? "&minus;" : "+" }}</span>
              </button>
              <div class="shop-menu__subpanel" *ngIf="openState === location.stateAbbr">
                <a *ngFor="let city of location.cities" class="shop-menu__link" [routerLink]="['/', 'equipment-rentals', 'all', locationRoute(city, location.stateAbbr)]">{{ city }}</a>
              </div>
            </div>
          </ng-container>
          <ng-container *ngSwitchDefault>
            <a class="shop-menu__link shop-menu__link--strong" [routerLink]="['/', section.route, 'all']" [queryParams]="section.queryParams">View all categories</a>
            <a *ngFor="let category of popularCategories[section.key]" class="shop-menu__link" [routerLink]="['/', section.route, category.name]" [queryParams]="section.queryParams">
              {{ category.name }} <span class="shop-menu__count">({{ category.count }})</span></a>
          </ng-container>
        </div>
      </li>
    </ul>
    <ul class="list-unstyled main-menu">
      <li *ngIf="storefrontEnabled && !commerceNavigation">
        <button type="button" class="shop-menu__toggle text-white fs-22" (click)="openSection = openSection === 'attachments' ? '' : 'attachments'"
          [attr.aria-expanded]="openSection === 'attachments'">
          Attachments <span class="shop-menu__caret" aria-hidden="true">{{ openSection === 'attachments' ? "&minus;" : "+" }}</span>
        </button>
        <div class="shop-menu__panel" [hidden]="openSection !== 'attachments'">
          <a class="shop-menu__link shop-menu__link--strong" routerLink="/shop/attachments">Shop all attachments</a>
          <div *ngFor="let machine of attachmentMachineTypes" class="shop-menu__group">
            <a class="shop-menu__link shop-menu__link--strong" [routerLink]="['/shop', 'attachments', machine.handle]">{{ machine.name }}</a>
            <a *ngFor="let category of categoriesFor(machine.handle)" class="shop-menu__link" [routerLink]="['/shop', 'attachments', machine.handle, category.handle]">{{ category.name }}</a>
          </div>
        </div>
        <div class="d-flex flex-wrap text-white bb mb-3 mt-3"></div>
      </li>
      <li *ngFor="let item of menuItems; last as isLast" [routerLinkActive]="['active']">
        <ng-container *ngIf="item.label != null">
          <a
            class="text-white fs-22 d-flex align-items-center"
            *ngIf="item.route != null"
            href
            [routerLink]="item.route"
            [attr.route]="item.route"
            title="{{ item.label }}"
          >
            {{ item.label }} <span *ngIf="item.new" class="badge badge-primary ml-3">New</span>
          </a>
          <a class="text-white fs-22" *ngIf="item.action != null" (click)="item.action()" title="{{ item.label }}">
            {{ item.label }}
          </a>
        </ng-container>

        <div class="d-flex flex-wrap text-white" [ngClass]="{ 'bb mb-3': !isLast, 'mt-3': !item.children }">
          <div class="mb-2" *ngFor="let subnavItem of item.children; last as isLast2">
            <a *ngIf="subnavItem.route" [routerLink]="[subnavItem.route]">{{ subnavItem.label }}</a>

            <a *ngIf="subnavItem.action != null" (click)="subnavItem.action()" title="{{ subnavItem.label }}">
              {{ subnavItem.label }}
            </a>
            <span class="mx-2" *ngIf="!isLast2">|</span>
          </div>
        </div>
      </li>
    </ul>
  </div>
</div>
